import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { class: "user" }
const _hoisted_4 = {
  key: 1,
  class: "setting-ctrl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_coffee = _resolveComponent("coffee")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_document = _resolveComponent("document")!
  const _component_Money = _resolveComponent("Money")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("a", {
      href: "/",
      class: "el-link"
    }, [
      _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("img", { src: "//res-cn.public.gblinker.com/gblinker/ops_assets/logo.png" }),
        _createElementVNode("label", { class: "name" }, "格布小包")
      ])
    ], -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_link, {
        underline: false,
        class: _normalizeClass(["menu-item", { active: _ctx.activeName == 'order' }]),
        href: "/order"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { color: "#314ee0" }, {
            default: _withCtx(() => [
              _createVNode(_component_coffee)
            ]),
            _: 1 /* STABLE */
          }),
          _cache[0] || (_cache[0] = _createTextVNode("下单"))
        ]),
        _: 1 /* STABLE */,
        __: [0]
      }, 8 /* PROPS */, ["class"]),
      _createVNode(_component_el_link, {
        underline: false,
        class: _normalizeClass(["menu-item", { active: _ctx.activeName == 'packages' }]),
        href: "/order/packages"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { color: "#314ee0" }, {
            default: _withCtx(() => [
              _createVNode(_component_document)
            ]),
            _: 1 /* STABLE */
          }),
          _cache[1] || (_cache[1] = _createTextVNode("我的包裹"))
        ]),
        _: 1 /* STABLE */,
        __: [1]
      }, 8 /* PROPS */, ["class"]),
      _createVNode(_component_el_link, {
        underline: false,
        class: _normalizeClass(["menu-item", { active: _ctx.activeName == 'unpaidPackages' }]),
        href: "/order/unpaid-packages"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { color: "#314ee0" }, {
            default: _withCtx(() => [
              _createVNode(_component_Money)
            ]),
            _: 1 /* STABLE */
          }),
          _cache[2] || (_cache[2] = _createTextVNode("待支付包裹"))
        ]),
        _: 1 /* STABLE */,
        __: [2]
      }, 8 /* PROPS */, ["class"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.showLogin)
        ? (_openBlock(), _createBlock(_component_el_link, {
            key: 0,
            underline: false,
            href: "/user/login"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("扫码登录")
            ])),
            _: 1 /* STABLE */,
            __: [3]
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_link, {
              underline: false,
              href: "/user/mine"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("设置")
              ])),
              _: 1 /* STABLE */,
              __: [4]
            }),
            _createVNode(_component_el_link, {
              underline: false,
              href: "/user/warehouse"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("仓库地址")
              ])),
              _: 1 /* STABLE */,
              __: [5]
            }),
            _createVNode(_component_el_link, {
              underline: false,
              onClick: _ctx.logout
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("退出")
              ])),
              _: 1 /* STABLE */,
              __: [6]
            }, 8 /* PROPS */, ["onClick"])
          ]))
    ])
  ]))
}